module.exports = __webpack_public_path__ + "37e75531cf1f9abce10e4bc72042ff2c.png";